"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
    onCreate: function () {
        this.state = {
            page: 1,
            pagesLen: 0,
            showShrink: false
        };
    },
    onInput: function (input) {
        if (!input.pagination || !input.data)
            return;
        this.state.pagesLen = parseInt(input.data.length / input.pagination);
    },
    onSelectItem: function (data) {
        this.emit('select', data);
    },
    onGoToPage: function (page) {
        this.state.page = page;
        this.checkCanLoad();
    },
    onNavigate: function (type, outbounds) {
        if (!outbounds)
            return;
        type == 'next' ? this.state.page++ : this.state.page--;
        this.checkCanLoad();
    },
    checkCanLoad: function () {
        if (!this.input.pagination)
            return;
        if (this.state.page > parseInt(this.state.pagesLen * 9 / 10))
            this.emit('canload', this.state.page, this.input.pagination);
    },
    onShowShrinkList: function (status) {
        this.state.showShrink = status || false;
        if (this.state.showShrink)
            setTimeout(() => {
                const shrinkBlock = this.getEl('shrink-block');
                shrinkBlock.scrollTop = shrinkBlock.scrollHeight;
            }, 100);
    },
    autoCloseShrinkList: function (e) {
        if (!$(e.target).closest('.shrinked').length)
            this.onShowShrinkList(false);
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Datatable/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Image_template = require("../../../components/Image/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Image_tag = marko_loadTag(Image_template),
    Bx_template = require("../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    marko_attrs = require("marko/dist/runtime/vdom/helpers/attrs"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    marko_forRange = require("marko/dist/runtime/helpers/for-range"),
    subscribe_template = require("@marko-tags/subscribe/index.marko"),
    subscribe_tag = marko_loadTag(subscribe_template),
    AutoScroll_template = require("marko-perfect-scrollbar/index.marko"),
    AutoScroll_tag = marko_loadTag(AutoScroll_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("6b9bbe"),
    marko_node0 = marko_createElement("div", {
        "class": "col"
      }, "4", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs0 = {
        "class": "col"
      },
    marko_attrs1 = {
        "class": "list-inline font-medium-4 float-right"
      },
    marko_attrs2 = {
        "class": "shrinked position-relative px-50 py-1"
      },
    marko_attrs3 = {
        "class": "d-inline-block cursor-pointer"
      },
    marko_attrs4 = {
        "class": "list-unstyled text-center"
      },
    marko_attrs5 = {
        "class": "px-1 py-50 nav-item"
      },
    marko_attrs6 = {
        "class": "px-1 py-50 nav-item"
      },
    marko_attrs7 = {
        "class": "table-header border-bottom border-3 m-0"
      },
    marko_attrs8 = {
        "class": "table-body"
      },
    marko_attrs9 = {
        "class": "text-center p-4"
      };

function render(input, out, __component, component, state) {
  var data = input;

  function macro_Tr(out, { rowset, index }) {
    out.be("tr", {
        "class": marko_classValue("m-0 nav-item cursor-pointer border-bottom animated fadeIn fast " + (input.stripped && (index % 2) ? "theme-bg-fade" : ""))
      }, "@" + ("tr-" + index), component, null, 1, {
        onclick: __component.d("click", "onSelectItem", false, [
            input.data[index]
          ])
      });

    marko_forOf(input.format, function({ key, label, type, style, wsadapt, col }, tdindex) {
      var $keyValue$0 = "@" + ("td-" + tdindex),
          $keyScope$0 = "[" + ($keyValue$0 + "]");

      out.be("td", marko_assign({
          "class": marko_classValue(marko_classValue([
            "p-1",
            col ? "col-" + col : false
          ]))
        }, marko_attrs(wsadapt)), $keyValue$0, component, null, 4);

      if (type == "image") {
        Image_tag({
            alt: "Image",
            src: rowset[key],
            class: "rounded",
            style: "width:40px"
          }, out, __component, "0" + $keyScope$0);
      } else if (type == "icon") {
        Bx_tag({
            type: rowset[key],
            class: "font-large-3"
          }, out, __component, "1" + $keyScope$0);
      } else {
        out.be("span", {
            "class": marko_classValue(style)
          }, "2" + $keyScope$0, component, null, 1);

        out.h(key == "trindex" ? index + 1 : Locale(rowset[key]), component);

        out.ee();
      }

      out.ee();
    });

    out.ee();
  }

  function macro_Paginagtion(out) {
    Row_tag({
        class: "table-footer py-2",
        renderBody: function(out) {
          out.n(marko_node0, component);

          if (input.pagination && (input.data.length > input.pagination)) {
            out.be("div", marko_attrs0, "5", component);

            out.be("ul", marko_attrs1, "6", component);

            const maxFirstLi = 3

            const shrinkAt = state.pagesLen > maxFirstLi && ( ( state.pagesLen - maxFirstLi ) > 2 )

            out.be("li", {
                "class": marko_classValue(marko_classValue([
                  "px-2 py-1",
                  state.page > 1 ? "cursor-pointer text-primary" : "d-none"
                ]))
              }, "7", component, null, 1, {
                onclick: __component.d("click", "onNavigate", false, [
                    "prev",
                    state.page > 1
                  ])
              });

            Bx_tag({
                type: "left-arrow-alt",
                class: "font-medium-5"
              }, out, __component, "8");

            out.ee();

            var $for$0 = 0;

            marko_forRange(1, shrinkAt ? maxFirstLi : state.pagesLen + ((state.pagesLen % 2) > 0), 1, function(index) {
              var $keyScope$1 = "[" + (($for$0++) + "]");

              out.e("li", {
                  "class": marko_classValue(marko_classValue([
                    "px-2 py-1",
                    "cursor-pointer " + (state.page == index ? "border-bottom border-3 text-primary" : "")
                  ]))
                }, "9" + $keyScope$1, component, 1, 1, {
                  onclick: __component.d("click", "onGoToPage", false, [
                      index
                    ])
                })
                .t(index, component);
            });

            if (shrinkAt) {
              out.be("li", marko_attrs2, "10", component);

              out.be("span", marko_attrs3, "11", component, null, 0, {
                  onclick: __component.d("click", "onShowShrinkList", false, [
                      true
                    ])
                });

              Bx_tag({
                  type: "dots-horizontal-rounded",
                  class: "font-medium-5"
                }, out, __component, "12");

              out.ee();

              subscribe_tag({
                  to: document,
                  __events: [
                    "on",
                    "click"
                  ]
                }, out, __component, "13", [
                [
                  "click",
                  "autoCloseShrinkList",
                  false
                ]
              ]);

              if (state.showShrink) {
                AutoScroll_tag({
                    class: "position-absolute bottom-0 theme-bg animated fadeIn faster shadow rounded",
                    height: "auto",
                    style: "max-height:210px;margin-left:-40%;margin-bottom:5px;",
                    renderBody: function(out) {
                      out.be("ul", marko_attrs4, "14", component);

                      var $for$1 = 0;

                      marko_forRange(state.pagesLen - 1, maxFirstLi + 1, -1, function(index) {
                        var $keyScope$2 = "[" + (($for$1++) + "]");

                        out.e("li", marko_attrs6, "15" + $keyScope$2, component, 1, 0, {
                            onclick: __component.d("click", "onGoToPage", false, [
                                index
                              ])
                          })
                          .t(index, component);
                      });

                      out.be("li", marko_attrs5, "16", component, null, 0, {
                          onclick: __component.d("click", "onShowShrinkList", false, [
                              false
                            ])
                        });

                      Bx_tag({
                          type: "dots-horizontal-rounded",
                          class: "font-medium-5"
                        }, out, __component, "17");

                      out.ee();

                      out.ee();
                    }
                  }, out, __component, "shrink-block");
              }

              out.ee();

              out.e("li", {
                  "class": marko_classValue(marko_classValue([
                    "px-2 py-1",
                    "cursor-pointer " + (state.page == state.pagesLen ? "border-bottom border-3 text-primary" : "")
                  ]))
                }, "18", component, 1, 1, {
                  onclick: __component.d("click", "onGoToPage", false, [
                      state.pagesLen
                    ])
                })
                .t(state.pagesLen, component);
            }

            out.be("li", {
                "class": marko_classValue(marko_classValue([
                  "px-2 py-1",
                  state.page < state.pagesLen ? "cursor-pointer text-primary" : "d-none"
                ]))
              }, "19", component, null, 1, {
                onclick: __component.d("click", "onNavigate", false, [
                    "next",
                    state.page < state.pagesLen
                  ])
              });

            Bx_tag({
                type: "right-arrow-alt",
                class: "font-medium-5"
              }, out, __component, "20");

            out.ee();

            out.ee();

            out.ee();
          }
        }
      }, out, __component, "3");
  }

  if (Array.isArray(input.data) && Array.isArray(input.format)) {
    marko_dynamicTag(out, macro_Paginagtion, null, null, null, null, __component, "27");

    out.be("table", {
        "class": marko_classValue(input.class)
      }, "21", component, null, 1);

    out.be("thead", marko_attrs7, "22", component);

    marko_forOf(input.format, function({ key, label, wsadapt, col }, index) {
      var $keyValue$3 = "@" + ("th-" + index),
          $keyScope$3 = "[" + ($keyValue$3 + "]");

      out.be("th", marko_assign({}, marko_attrs(wsadapt), {
          "class": marko_classValue(marko_classValue([
            "p-1",
            col ? "-" + col : false
          ]))
        }), $keyValue$3, component, null, 4);

      Locale_tag({
          text: label,
          class: "strong"
        }, out, __component, "23" + $keyScope$3);

      out.ee();
    });

    out.ee();

    out.be("tbody", marko_attrs8, "24", component);

    const dataLen = input.data.length

    if (dataLen) {
      if (input.pagination) {
        const endPage = input.pagination * state.page

        const startPage = endPage - input.pagination

        var $for$2 = 0;

        marko_forRange(startPage, (endPage < dataLen ? endPage : dataLen) - 1, 1, function(trindex) {
          var $keyScope$4 = "[" + (($for$2++) + "]");

          marko_dynamicTag(out, macro_Tr, function() {
            return {
                rowset: input.data[trindex],
                index: trindex
              };
          }, null, null, null, __component, "28" + $keyScope$4);
        });
      } else {
        var $for$3 = 0;

        marko_forOf(input.data, function(value, trindex) {
          var $keyScope$5 = "[" + (($for$3++) + "]");

          marko_dynamicTag(out, macro_Tr, function() {
            return {
                rowset: value,
                index: trindex
              };
          }, null, null, null, __component, "29" + $keyScope$5);
        });
      }
    } else {
      out.be("div", marko_attrs9, "25", component);

      Locale_tag({
          text: input.loading ? "Loading ..." : "No data"
        }, out, __component, "26");

      out.ee();
    }

    out.ee();

    out.ee();

    marko_dynamicTag(out, macro_Paginagtion, null, null, null, null, __component, "30");
  }
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
